var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 18,
    viewBox: "0 0 28 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6333 14.5782H11.2C10.8134 14.5782 10.5 14.3869 10.5 14.1508V7.16961C10.5 6.93355 10.8134 6.74219 11.2 6.74219H22.6333C23.02 6.74219 23.3333 6.93355 23.3333 7.16961V14.1508C23.3333 14.3869 23.02 14.5782 22.6333 14.5782Z",
    stroke: "#3E5692",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 6.74152V3.60711C17.5003 3.37105 17.187 3.17969 16.8003 3.17969H5.36699C4.98039 3.17969 4.66699 3.37105 4.66699 3.60711V10.5883C4.66699 10.8244 4.98039 11.0157 5.36699 11.0157H10.5003",
    stroke: "#3E5692",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.4c8419e664b9fd30c72885e9787b1c1d.svg";
export { ForwardRef as ReactComponent };